module.exports = __webpack_public_path__ + "static/media/bg-mobilefull.d052e0b0.png";